export default __webpack_public_path__ + "7d01df49929dd410e2471a9900fd8ce8.svg";